import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Time: any;
};


export type Address = {
  __typename?: 'Address';
  fullName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  cityLocality: Scalars['String'];
  countryCode: Scalars['String'];
  stateProvinceCode: Scalars['String'];
  postalCode: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  fullName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  cityLocality: Scalars['String'];
  countryCode: Scalars['String'];
  stateProvinceCode: Scalars['String'];
  postalCode: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
};

export type AlbumDesign = {
  __typename?: 'AlbumDesign';
  id: Scalars['ID'];
  createdAt: Scalars['Time'];
  pages: Array<AlbumPage>;
};

export type AlbumPage = {
  __typename?: 'AlbumPage';
  id: Scalars['ID'];
  createdAt: Scalars['Time'];
  pageNumber: Scalars['Int'];
  photoDesignJSON?: Maybe<Scalars['String']>;
  photoThumbnailURL?: Maybe<Scalars['String']>;
  photoProductionURL?: Maybe<Scalars['String']>;
  videoMediaId?: Maybe<Scalars['ID']>;
  videoMedia?: Maybe<MediaEntry>;
  designId?: Maybe<Scalars['ID']>;
  design?: Maybe<Design>;
  cardVideoURL?: Maybe<Scalars['String']>;
  cardVideoSHA256?: Maybe<Scalars['String']>;
};

export type BalanceEntry = {
  __typename?: 'BalanceEntry';
  id: Scalars['ID'];
  createdAt: Scalars['Time'];
  originalCashInCents: Scalars['Int'];
  cashRemainingInCents: Scalars['Int'];
  products: Array<BalanceEntryProduct>;
  vendorSale?: Maybe<VendorSale>;
  vendorDisplayName: Scalars['String'];
  amountPaidInCents?: Maybe<Scalars['Int']>;
  refundRequestedAt?: Maybe<Scalars['Time']>;
  refundCompletedAt?: Maybe<Scalars['Time']>;
};

export type BalanceEntryProduct = {
  __typename?: 'BalanceEntryProduct';
  productId: Scalars['String'];
  originalQuantity: Scalars['Int'];
  quantityRemaining: Scalars['Int'];
};

export type BalanceUsage = {
  __typename?: 'BalanceUsage';
  id: Scalars['ID'];
  createdAt: Scalars['Time'];
  products: Array<BalanceUsageProduct>;
  vendorSaleVendorId?: Maybe<Scalars['String']>;
  vendorSaleId?: Maybe<Scalars['String']>;
  cashInCents: Scalars['Int'];
  refundedAt?: Maybe<Scalars['Time']>;
};

export type BalanceUsageProduct = {
  __typename?: 'BalanceUsageProduct';
  productId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type BalanceUsed = {
  __typename?: 'BalanceUsed';
  productBalanceUsed?: Maybe<Array<ProductBalanceUsed>>;
  cashBalanceUsed?: Maybe<Array<CashBalanceUsed>>;
};

export type BookLineItemInput = {
  coverId: Scalars['String'];
  quantity: Scalars['Int'];
};

export enum BookState {
  Created = 'created',
  Hold = 'hold',
  Loaded = 'loaded',
  Packed = 'packed',
  Shipped = 'shipped',
  Cancelled = 'cancelled',
  Archived = 'archived'
}

export enum BookType {
  FiveInch = 'five_inch',
  SevenInch = 'seven_inch',
  TenInch = 'ten_inch'
}

export type CardVideoStatus = {
  __typename?: 'CardVideoStatus';
  downloadStatus?: Maybe<Scalars['String']>;
  percentageDownloaded?: Maybe<Scalars['Int']>;
  transferStatus?: Maybe<Scalars['String']>;
  percentageTransferred?: Maybe<Scalars['Int']>;
};

export type CashBalanceUsed = {
  __typename?: 'CashBalanceUsed';
  balanceEntry: BalanceEntry;
  cashInCents: Scalars['Int'];
};

export type Clip = {
  __typename?: 'Clip';
  startMs: Scalars['Int'];
  endMs: Scalars['Int'];
  rotation: Scalars['Int'];
};

export type Cost = {
  __typename?: 'Cost';
  listInCents: Scalars['Int'];
  discountInCents: Scalars['Int'];
  actualInCents: Scalars['Int'];
  currency: Currency;
};

export type Costs = {
  __typename?: 'Costs';
  product: Cost;
  shipping: Cost;
  tax: Cost;
  total: Cost;
  balanceUsed: BalanceUsed;
};

export type Cover = {
  __typename?: 'Cover';
  id: Scalars['ID'];
  createdAt: Scalars['Time'];
  lastModifiedAt?: Maybe<Scalars['Time']>;
  createdByCustomerId: Scalars['ID'];
  approvedAt?: Maybe<Scalars['Time']>;
  approvedBy?: Maybe<Scalars['String']>;
  isFull: Scalars['Boolean'];
  thumbnailImageURL?: Maybe<Scalars['String']>;
  productionImageURL?: Maybe<Scalars['String']>;
  designJSON?: Maybe<Scalars['String']>;
  usedByDestinations?: Maybe<Array<Destination>>;
};

export enum Currency {
  Usd = 'USD'
}

export type Customer = {
  __typename?: 'Customer';
  id: Scalars['ID'];
  createdAt: Scalars['Time'];
  email: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  flagOrders?: Maybe<FlagInfo>;
  paymentCustomerId: Scalars['ID'];
  subscribedToMarketingEmails: Scalars['Boolean'];
  balance?: Maybe<CustomerBalance>;
};

export type CustomerBalance = {
  __typename?: 'CustomerBalance';
  products: Array<CustomerBalanceProduct>;
  cashInCents: Scalars['Int'];
  cashEntries: Array<BalanceEntry>;
};

export type CustomerBalanceProduct = {
  __typename?: 'CustomerBalanceProduct';
  quantity: Scalars['Int'];
  entries: Array<BalanceEntry>;
  product: Product;
};

export type CustomerWithActivity = {
  __typename?: 'CustomerWithActivity';
  customer: Customer;
  payments: Array<Payment>;
};

export type Design = {
  __typename?: 'Design';
  id: Scalars['ID'];
  orderId: Scalars['ID'];
  createdAt: Scalars['Time'];
  media?: Maybe<Array<MediaEntry>>;
  generation: Scalars['ID'];
  durationSeconds: Scalars['Float'];
  manualGain?: Maybe<Scalars['Int']>;
  manualOrientation: Scalars['String'];
  ducking: Scalars['Float'];
  renders?: Maybe<Array<Render>>;
  isBlank: Scalars['Boolean'];
};

export type DesignWithDestinations = {
  __typename?: 'DesignWithDestinations';
  design?: Maybe<Design>;
  destinations?: Maybe<Array<Destination>>;
};

export type Destination = {
  __typename?: 'Destination';
  id: Scalars['ID'];
  designId: Scalars['ID'];
  orderId: Scalars['ID'];
  createdAt: Scalars['Time'];
  state: Scalars['String'];
  items?: Maybe<Array<PackageItem>>;
  packages?: Maybe<Array<Package>>;
  bookType?: Maybe<BookType>;
  giftMessage?: Maybe<Message>;
  extras?: Maybe<Array<Extra>>;
  quantity: Scalars['Int'];
  address?: Maybe<Address>;
  digital: Scalars['Boolean'];
  coverId?: Maybe<Scalars['ID']>;
  insideCoverId?: Maybe<Scalars['ID']>;
  backCoverId?: Maybe<Scalars['ID']>;
  cover?: Maybe<Cover>;
  insideCover?: Maybe<Cover>;
  backCover?: Maybe<Cover>;
  coversPrinted: Scalars['Int'];
  albumDesignId?: Maybe<Scalars['ID']>;
  albumDesign?: Maybe<AlbumDesign>;
  metadataJSON?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  shippingSpeed?: Maybe<Scalars['String']>;
  shippingServiceCode?: Maybe<Scalars['String']>;
};

export type DestinationCosts = {
  __typename?: 'DestinationCosts';
  destinationId: Scalars['ID'];
  costs: Costs;
};

export type Device = {
  __typename?: 'Device';
  id: Scalars['String'];
  status: Scalars['String'];
  transferredOrderId?: Maybe<Scalars['ID']>;
  video: DeviceVideoStatus;
};

export type DeviceVideoStatus = {
  __typename?: 'DeviceVideoStatus';
  transferStatus?: Maybe<Scalars['String']>;
  percentageTransferred?: Maybe<Scalars['Int']>;
};

export type Discount = {
  __typename?: 'Discount';
  id: Scalars['ID'];
  type: DiscountType;
  value: Scalars['Int'];
  oneTime: Scalars['Boolean'];
};

export type DiscountInput = {
  id: Scalars['ID'];
  type: DiscountType;
  value: Scalars['Int'];
  oneTime: Scalars['Boolean'];
};

export enum DiscountType {
  Percent = 'percent',
  Amount = 'amount',
  Book = 'book'
}

export type Dropoff = {
  __typename?: 'Dropoff';
  occurred_at: Scalars['String'];
  scanner_email: Scalars['String'];
  scanner_name: Scalars['String'];
  device: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
};

export type Extra = {
  __typename?: 'Extra';
  id: Scalars['ID'];
};

export type ExtraInput = {
  id: Scalars['ID'];
};

export type FinalizeDialogState = {
  __typename?: 'FinalizeDialogState';
  isOpen?: Maybe<Scalars['Boolean']>;
  orderId?: Maybe<Scalars['ID']>;
  showWrongVideoMessage?: Maybe<Scalars['Boolean']>;
  showLabelSection?: Maybe<Scalars['Boolean']>;
  showVideoSection?: Maybe<Scalars['Boolean']>;
  allowAutoPrint?: Maybe<Scalars['Boolean']>;
};

export type FlagInfo = {
  __typename?: 'FlagInfo';
  createdByEmail: Scalars['String'];
  createdByName: Scalars['String'];
  createdAt: Scalars['Time'];
  description?: Maybe<Scalars['String']>;
  emoji?: Maybe<Array<Scalars['String']>>;
};

export type FlagInfoInput = {
  createdByEmail?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Time']>;
  description?: Maybe<Scalars['String']>;
  emoji?: Maybe<Array<Scalars['String']>>;
};

export type FormDownload = {
  __typename?: 'FormDownload';
  href?: Maybe<Scalars['String']>;
};

export type FulfillmentEvent = {
  __typename?: 'FulfillmentEvent';
  id: Scalars['ID'];
  createdAt: Scalars['Time'];
  byUserId: Scalars['ID'];
  packageItemId?: Maybe<Scalars['ID']>;
  packageId?: Maybe<Scalars['ID']>;
  type: FulfillmentEventType;
  metadataJSON: Scalars['String'];
};

export enum FulfillmentEventType {
  LoadBook = 'load_book',
  Pack = 'pack',
  PrintCoupon = 'print_coupon',
  PrintMessage = 'print_message',
  PrintLabel = 'print_label',
  QaPass = 'qa_pass',
  QaFail = 'qa_fail',
  TenderToShipper = 'tender_to_shipper'
}

export type HelpScoutConversation = {
  __typename?: 'HelpScoutConversation';
  id: Scalars['Int'];
  isDraft: Scalars['Boolean'];
  number: Scalars['Int'];
  threadCount: Scalars['Int'];
  status: Scalars['String'];
  subject: Scalars['String'];
  preview: Scalars['String'];
  createdAt: Scalars['Time'];
  modifiedAt?: Maybe<Scalars['Time']>;
  closedAt?: Maybe<Scalars['Time']>;
};

export type HelpScoutConversationsResponse = {
  __typename?: 'HelpScoutConversationsResponse';
  conversations: Array<HelpScoutConversation>;
};

export type Id3Info = {
  __typename?: 'ID3Info';
  artist?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  albumArt?: Maybe<Scalars['String']>;
};

export enum ImageType {
  Thumbnail = 'Thumbnail',
  Production = 'Production'
}

export enum ItemFulfillmentState {
  Ready = 'ready',
  Hold = 'hold',
  Created = 'created',
  Pulled = 'pulled',
  Packed = 'packed',
  Cancelled = 'cancelled',
  Archived = 'archived'
}

export enum ItemType {
  Book = 'book',
  Accessory = 'accessory',
  GiftCard = 'gift_card'
}

export type LabelDownload = {
  __typename?: 'LabelDownload';
  pdf?: Maybe<Scalars['String']>;
  png?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
};

export type LoadingEvent = {
  __typename?: 'LoadingEvent';
  id: Scalars['String'];
  type: Scalars['String'];
  createdAt: Scalars['Time'];
  createdBy: Scalars['String'];
};

export type LoyaltyCodeResponse = {
  __typename?: 'LoyaltyCodeResponse';
  qr: QrCode;
  link: Scalars['String'];
};

export type ManyOrdersResponse = {
  __typename?: 'ManyOrdersResponse';
  orders: Array<Order>;
};

export type MediaEntry = {
  __typename?: 'MediaEntry';
  id: Scalars['ID'];
  createdAt: Scalars['Time'];
  encodedLocation: Scalars['String'];
  mezzanineLocation: Scalars['String'];
  posterLocation: Scalars['String'];
  thumbnailLocation: Scalars['String'];
  videoThumbnailLocation: Scalars['String'];
  encodeProgress: Scalars['Float'];
  encodeAttempts: Scalars['Int'];
  format?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  durationSeconds?: Maybe<Scalars['Float']>;
  sizeKB?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  rotation?: Maybe<Scalars['Int']>;
  isVertical?: Maybe<Scalars['Boolean']>;
  mediaVolume: Scalars['Float'];
  backgroundVolume: Scalars['Float'];
  clips: Array<Clip>;
  id3?: Maybe<Id3Info>;
  signedEncodedLocation?: Maybe<Scalars['String']>;
  signedPosterLocation?: Maybe<Scalars['String']>;
  signedThumbnailLocation?: Maybe<Scalars['String']>;
  signedVideoThumbnailLocation?: Maybe<Scalars['String']>;
};

export type MediaEntryInput = {
  type: Scalars['String'];
  location: Scalars['String'];
  format?: Maybe<Scalars['String']>;
  durationSeconds?: Maybe<Scalars['Float']>;
  sizeKB?: Maybe<Scalars['Int']>;
};

export type MediaInput = {
  /**
   * This will cause the method to error if the current generation value on this design does not
   * match the one passed. The generation value updates every time the design is changed.
   *
   * It is strongly recommended that you pass the value you got when you loaded the design or last changed it,
   * IF this is an autosave application (a situation where the design is saving itself). This will prevent
   * you from accidentally clobbering changes made in another tab or through a bug. If this change
   * is happening due to user action like clicking 'Save' it is recommended you do NOT set this,
   * as we don't want to block the user from saving intentionally even if it might overwrite something.
   */
  ifPrevGenerationMatches?: Maybe<Scalars['ID']>;
  media: Array<MediaEntryInput>;
};

export type Message = {
  __typename?: 'Message';
  body: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  setOrderActive: OrderResponse;
  setOrderStatus: OrderResponse;
  refund: Payment;
  reencode: OrderResponse;
  voidShippingLabel: ShippingLabel;
  orderShipmentFromRate: ShippingLabel;
  finalizeOrder: OrderResponse;
  replaceVideos: OrderResponse;
  updateOrder: OrderResponse;
  updateCustomer: Customer;
  updateDiscount: Discount;
  addDiscount: Discount;
  createShopifyOrder: ShopifyOrder;
  updateCustomCoverApproval: Cover;
  updateCoverPrintCount: Destination;
  updateDestinationMetadata: Destination;
};


export type MutationSetOrderActiveArgs = {
  id: Scalars['ID'];
  active: Scalars['Boolean'];
};


export type MutationSetOrderStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationRefundArgs = {
  paymentID: Scalars['ID'];
  amountInCents: Scalars['Int'];
};


export type MutationReencodeArgs = {
  orderID: Scalars['ID'];
};


export type MutationVoidShippingLabelArgs = {
  orderID: Scalars['ID'];
  labelID: Scalars['ID'];
};


export type MutationOrderShipmentFromRateArgs = {
  orderID: Scalars['ID'];
  rateID: Scalars['ID'];
  isReturn?: Maybe<Scalars['Boolean']>;
};


export type MutationFinalizeOrderArgs = {
  orderID: Scalars['ID'];
};


export type MutationReplaceVideosArgs = {
  orderID: Scalars['ID'];
  newVideoURLs: Array<Scalars['String']>;
  prevVideoURLs: Array<Scalars['String']>;
};


export type MutationUpdateOrderArgs = {
  orderID: Scalars['ID'];
  fields: Array<Scalars['String']>;
  prevValues: UpdatableOrderProperties;
  newValues: UpdatableOrderProperties;
};


export type MutationUpdateCustomerArgs = {
  customerID?: Maybe<Scalars['ID']>;
  customerEmail?: Maybe<Scalars['String']>;
  fields: Array<Scalars['String']>;
  prevValues: UpdatableCustomerProperties;
  newValues: UpdatableCustomerProperties;
};


export type MutationUpdateDiscountArgs = {
  discount: DiscountInput;
};


export type MutationAddDiscountArgs = {
  discount: DiscountInput;
};


export type MutationCreateShopifyOrderArgs = {
  order: ShopifyOrderInput;
};


export type MutationUpdateCustomCoverApprovalArgs = {
  coverID: Scalars['ID'];
  approved: Scalars['Boolean'];
};


export type MutationUpdateCoverPrintCountArgs = {
  destinationID: Scalars['ID'];
  oldValue: Scalars['Int'];
  newValue: Scalars['Int'];
};


export type MutationUpdateDestinationMetadataArgs = {
  destinationID: Scalars['ID'];
  metadataJSON: Scalars['String'];
};

export type Order = {
  __typename?: 'Order';
  balanceUsages?: Maybe<Array<BalanceUsage>>;
  cancelledAt?: Maybe<Scalars['Time']>;
  cardVideoEncodeAttempts?: Maybe<Scalars['Int']>;
  cardVideoEncodeProgress?: Maybe<Scalars['Float']>;
  cardVideoEncodedConfig?: Maybe<VideoConfiguration>;
  cardVideoSHA256?: Maybe<Scalars['String']>;
  cardVideoURL?: Maybe<Scalars['String']>;
  cost?: Maybe<Pricing>;
  createdAt: Scalars['Time'];
  customer?: Maybe<Customer>;
  customerEmail: Scalars['String'];
  customerId?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  designs?: Maybe<Array<DesignWithDestinations>>;
  discountId?: Maybe<Scalars['ID']>;
  finalizedAt?: Maybe<Scalars['Time']>;
  finalizedBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isEGift: Scalars['Boolean'];
  isGift: Scalars['Boolean'];
  isReplacement: Scalars['Boolean'];
  items?: Maybe<Array<PackageItem>>;
  loyaltyCode?: Maybe<Scalars['ID']>;
  manualGain?: Maybe<Scalars['Int']>;
  manualOrientation: Scalars['String'];
  name: Scalars['String'];
  notes?: Maybe<Array<OrderNote>>;
  packages?: Maybe<Array<Package>>;
  paidAt?: Maybe<Scalars['Time']>;
  paymentIntent?: Maybe<Payment>;
  payments?: Maybe<Array<Payment>>;
  reservedAt?: Maybe<Scalars['Time']>;
  reservedBy?: Maybe<Scalars['String']>;
  scheduledDeliveryDate?: Maybe<Scalars['Time']>;
  shareVideoEncodeAttempts?: Maybe<Scalars['Int']>;
  shareVideoEncodeProgress?: Maybe<Scalars['Float']>;
  shareVideoSHA256?: Maybe<Scalars['String']>;
  shareVideoThumbnailURL?: Maybe<Scalars['String']>;
  shareVideoURL?: Maybe<Scalars['String']>;
  shippingLabels?: Maybe<Array<ShippingLabel>>;
  shopify?: Maybe<ShopifyOrder>;
  state: OrderState;
  status: Scalars['String'];
  vendorSale?: Maybe<VendorSale>;
  video: CardVideoStatus;
};

export type OrderFilters = {
  express?: Maybe<Scalars['Boolean']>;
  shippedNoPickup?: Maybe<Scalars['Boolean']>;
  shipped?: Maybe<Scalars['Boolean']>;
  late?: Maybe<Scalars['Boolean']>;
  scheduled?: Maybe<Scalars['Boolean']>;
  preorder?: Maybe<Scalars['Boolean']>;
  vendor?: Maybe<Scalars['Boolean']>;
};

export type OrderNote = {
  __typename?: 'OrderNote';
  id: Scalars['String'];
  createdAt: Scalars['Time'];
  createdBy: User;
  content: Scalars['String'];
};

export type OrderNoteInput = {
  id: Scalars['String'];
  createdAt: Scalars['Time'];
  createdBy: UserInput;
  content: Scalars['String'];
};

export type OrderResponse = {
  __typename?: 'OrderResponse';
  order: Order;
};

export enum OrderState {
  Draft = 'draft',
  Paid = 'paid',
  Complete = 'complete',
  Cancelled = 'cancelled',
  Archived = 'archived'
}

export enum Orientation {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}

export type Package = {
  __typename?: 'Package';
  id: Scalars['ID'];
  createdAt: Scalars['Time'];
  destinations?: Maybe<Array<Destination>>;
  orders?: Maybe<Array<Order>>;
  state?: Maybe<PackageState>;
  size: Scalars['String'];
  address: Address;
  items?: Maybe<Array<PackageItem>>;
  shippingSpeed?: Maybe<Scalars['String']>;
  shippingServiceCode?: Maybe<Scalars['String']>;
  shippingLabels?: Maybe<Array<ShippingLabel>>;
};

export type PackageItem = {
  __typename?: 'PackageItem';
  id: Scalars['ID'];
  createdAt: Scalars['Time'];
  sku: Scalars['String'];
  type: ItemType;
  state: ItemFulfillmentState;
  order?: Maybe<Order>;
  destination: Destination;
};

export enum PackageState {
  Created = 'created',
  Hold = 'hold',
  Ready = 'ready',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Lost = 'lost',
  Damaged = 'damaged',
  Cancelled = 'cancelled',
  Returned = 'returned'
}

export type PaginatedOrders = {
  __typename?: 'PaginatedOrders';
  cursor: Scalars['String'];
  orders: Array<Order>;
};

export type Payment = {
  __typename?: 'Payment';
  id: Scalars['ID'];
  createdAt: Scalars['Time'];
  stripeCustomerId: Scalars['String'];
  state: PaymentState;
  stateUpdatedAt?: Maybe<Scalars['Time']>;
  lastAttemptAt?: Maybe<Scalars['Time']>;
  successAt?: Maybe<Scalars['Time']>;
  amountInCents: Scalars['Int'];
  amountRefundedInCents: Scalars['Int'];
  currency: Currency;
  refunds?: Maybe<Array<Refund>>;
  isPreorder: Scalars['Boolean'];
  discountId: Scalars['String'];
  orderId: Scalars['String'];
  clientSecret?: Maybe<Scalars['String']>;
};

export enum PaymentState {
  RequiresPaymentMethod = 'requires_payment_method',
  RequiresConfirmation = 'requires_confirmation',
  RequiresAction = 'requires_action',
  Processing = 'processing',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled'
}

export type Pricing = {
  __typename?: 'Pricing';
  total: Costs;
  byDestination: Array<DestinationCosts>;
};

export type Product = {
  __typename?: 'Product';
  id: Scalars['String'];
  createdAt: Scalars['Time'];
  displayName: Scalars['String'];
  type: ProductType;
  sizeIn?: Maybe<Scalars['Int']>;
  formFactor?: Maybe<ProductFormFactor>;
  durationSec?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  quantityDC?: Maybe<Scalars['Int']>;
  allowSale: Scalars['Boolean'];
  priceInCents: Scalars['Int'];
  taxable: Scalars['Boolean'];
  discount: Scalars['Boolean'];
};

export type ProductBalanceUsed = {
  __typename?: 'ProductBalanceUsed';
  product: Product;
  balanceEntry: BalanceEntry;
  quantity: Scalars['Int'];
};

export enum ProductFormFactor {
  Square = 'square',
  Rect = 'rect'
}

export enum ProductType {
  Player = 'player',
  Cover = 'cover',
  Extra = 'extra',
  Shipping = 'shipping',
  Other = 'other'
}

export type QrCode = {
  __typename?: 'QRCode';
  dataURL: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  activeCustomCovers?: Maybe<Array<Cover>>;
  albumBatchPrintFilesURL: Scalars['String'];
  albumDesign?: Maybe<AlbumDesign>;
  albumOrders: Array<Order>;
  albumPrintFilesURL: Scalars['String'];
  allOrders: PaginatedOrders;
  customerInfo: CustomerWithActivity;
  devices: Array<Maybe<Device>>;
  discounts: Array<Discount>;
  finalizeDialogState?: Maybe<FinalizeDialogState>;
  helpScoutConversations: HelpScoutConversationsResponse;
  loyaltyCode: LoyaltyCodeResponse;
  myOrders: Array<Order>;
  order: Order;
  orders: Array<Order>;
  reservedOrders: Array<Order>;
  searchCustomers: Array<Customer>;
  searchOrders: Array<Order>;
  searchPackages: Array<Package>;
  shippingCarriers: Array<Maybe<ShippingCarrier>>;
  shippingRates: Array<ShippingRate>;
  shippingState?: Maybe<ShippingState>;
  signUpload: SignedUrlResponse;
  signVideoURLs: SignedUrLsResponse;
  videoURL: VideoRef;
};


export type QueryAlbumBatchPrintFilesUrlArgs = {
  albumDesignIds: Array<Scalars['ID']>;
};


export type QueryAlbumDesignArgs = {
  albumDesignId: Scalars['ID'];
};


export type QueryAlbumPrintFilesUrlArgs = {
  albumDesignId: Scalars['ID'];
};


export type QueryAllOrdersArgs = {
  limit: Scalars['Int'];
  cursor: Scalars['String'];
  filters?: Maybe<OrderFilters>;
};


export type QueryCustomerInfoArgs = {
  customerID: Scalars['ID'];
};


export type QueryHelpScoutConversationsArgs = {
  customerEmails: Array<Scalars['String']>;
};


export type QueryLoyaltyCodeArgs = {
  orderID: Scalars['ID'];
};


export type QueryMyOrdersArgs = {
  activeFulfillers?: Maybe<Scalars['Int']>;
  fulfillerIndex?: Maybe<Scalars['Int']>;
};


export type QueryOrderArgs = {
  orderID: Scalars['ID'];
};


export type QuerySearchCustomersArgs = {
  query: Scalars['String'];
};


export type QuerySearchOrdersArgs = {
  query: Scalars['String'];
  destinationsBecomeOrders?: Maybe<Scalars['Boolean']>;
};


export type QuerySearchPackagesArgs = {
  query: Scalars['String'];
  filters: Array<Scalars['String']>;
};


export type QueryShippingRatesArgs = {
  orderID: Scalars['ID'];
  fromOrToWarehouse: WarehouseCode;
  isReturn?: Maybe<Scalars['Boolean']>;
  saturdayDelivery?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
};


export type QuerySignUploadArgs = {
  extension?: Maybe<Scalars['String']>;
};


export type QuerySignVideoUrLsArgs = {
  urls: Array<Scalars['String']>;
};


export type QueryVideoUrlArgs = {
  orderID: Scalars['ID'];
};

export type Refund = {
  __typename?: 'Refund';
  id: Scalars['ID'];
  createdAt: Scalars['Time'];
  amountInCents: Scalars['Int'];
  currency: Currency;
};

export type ReleaseResponse = {
  __typename?: 'ReleaseResponse';
  ordersReleased: Scalars['Int'];
};

export type Render = {
  __typename?: 'Render';
  id: Scalars['ID'];
  formFactor?: Maybe<ProductFormFactor>;
  size?: Maybe<RenderSize>;
  task: Scalars['String'];
  encodedConfig?: Maybe<VideoConfiguration>;
  customerWaiting: Scalars['Boolean'];
  url: Scalars['String'];
  signedURL: Scalars['String'];
  sha256: Scalars['String'];
  encodeProgress: Scalars['Float'];
  encodeAttempts: Scalars['Int'];
  encodeStart?: Maybe<Scalars['Time']>;
  sizeKB?: Maybe<Scalars['Int']>;
};

export enum RenderSize {
  FiveIn = 'five_in',
  SevenIn = 'seven_in',
  TenIn = 'ten_in'
}

export type Shipment = {
  __typename?: 'Shipment';
  shipment_id: Scalars['ID'];
};

export type ShippingCarrier = {
  __typename?: 'ShippingCarrier';
  carrier_id: Scalars['ID'];
  carrier_code: Scalars['String'];
  nickname: Scalars['String'];
  friendly_name: Scalars['String'];
};

export type ShippingCost = {
  __typename?: 'ShippingCost';
  currency: Scalars['String'];
  amount: Scalars['Float'];
};

export type ShippingLabel = {
  __typename?: 'ShippingLabel';
  label_id: Scalars['ID'];
  status: Scalars['String'];
  shipment_id: Scalars['String'];
  ship_date: Scalars['String'];
  created_at: Scalars['String'];
  tracking_number: Scalars['String'];
  is_return_label: Scalars['Boolean'];
  is_international: Scalars['Boolean'];
  batch_id?: Maybe<Scalars['ID']>;
  carrier_id: Scalars['ID'];
  service_code: Scalars['String'];
  package_code: Scalars['String'];
  voided: Scalars['Boolean'];
  voided_at?: Maybe<Scalars['String']>;
  label_format: Scalars['String'];
  label_layout: Scalars['String'];
  trackable: Scalars['Boolean'];
  carrier_code: Scalars['String'];
  insurance_claim: Scalars['String'];
  label_download?: Maybe<LabelDownload>;
  form_download?: Maybe<FormDownload>;
  insurance_cost?: Maybe<ShippingCost>;
  shipment_cost?: Maybe<ShippingCost>;
  dest_country_code?: Maybe<Scalars['String']>;
  dest_postal_code?: Maybe<Scalars['String']>;
  tracking_status: Scalars['String'];
  carrier_tracking_status?: Maybe<Scalars['String']>;
  estimated_delivery_date?: Maybe<Scalars['String']>;
  actual_delivery_date?: Maybe<Scalars['String']>;
  tracking_updated_at?: Maybe<Scalars['String']>;
  exception_description?: Maybe<Scalars['String']>;
  events?: Maybe<Array<TrackingEvent>>;
  dropoffs?: Maybe<Array<Dropoff>>;
  fulfillment_id?: Maybe<Scalars['String']>;
  is_return?: Maybe<Scalars['Boolean']>;
};

export type ShippingRate = {
  __typename?: 'ShippingRate';
  rate_id: Scalars['ID'];
  rate_type: Scalars['String'];
  carrier_id: Scalars['String'];
  delivery_days: Scalars['Int'];
  guaranteed_service: Scalars['Boolean'];
  estimated_delivery_date: Scalars['String'];
  carrier_delivery_days: Scalars['String'];
  ship_date: Scalars['String'];
  package_type?: Maybe<Scalars['String']>;
  negotiated_rate: Scalars['Boolean'];
  service_type: Scalars['String'];
  service_code: Scalars['String'];
  saturday_delivery: Scalars['Boolean'];
  trackable: Scalars['Boolean'];
  validation_status: Scalars['String'];
  carrier_code: Scalars['String'];
  carrier_nickname: Scalars['String'];
  carrier_friendly_name: Scalars['String'];
  error_messages?: Maybe<Array<Scalars['String']>>;
  warning_messages?: Maybe<Array<Scalars['String']>>;
  other_amount: ShippingCost;
  confirmation_amount: ShippingCost;
  insurance_amount: ShippingCost;
  tax_amount: ShippingCost;
  shipping_amount: ShippingCost;
};

export type ShippingService = {
  __typename?: 'ShippingService';
  carrier_id: Scalars['ID'];
  carrier_code: Scalars['String'];
  service_code: Scalars['String'];
  name: Scalars['String'];
  domestic: Scalars['Boolean'];
  international: Scalars['Boolean'];
};

export type ShippingState = {
  __typename?: 'ShippingState';
  selectedShippingRate?: Maybe<ShippingRate>;
};

export type ShopifyAddress = {
  __typename?: 'ShopifyAddress';
  address1: Scalars['String'];
  address2: Scalars['String'];
  city: Scalars['String'];
  company: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
  phone: Scalars['String'];
  province: Scalars['String'];
  provinceCode: Scalars['String'];
  zip: Scalars['String'];
};

export type ShopifyFulfillment = {
  __typename?: 'ShopifyFulfillment';
  status: Scalars['String'];
  service: Scalars['String'];
  updatedAt?: Maybe<Scalars['Time']>;
  trackingCompany: Scalars['String'];
  shipmentStatus: Scalars['String'];
  trackingNumber: Scalars['String'];
  trackingNumbers?: Maybe<Array<Scalars['String']>>;
  trackingURL: Scalars['String'];
  trackingURLs?: Maybe<Array<Scalars['String']>>;
};

export type ShopifyImage = {
  __typename?: 'ShopifyImage';
  id: Scalars['Int'];
  position: Scalars['Int'];
  width: Scalars['Int'];
  height: Scalars['Int'];
  src: Scalars['String'];
};

export type ShopifyLineItem = {
  __typename?: 'ShopifyLineItem';
  quantity: Scalars['Int'];
  price: Scalars['Float'];
  totalDiscount?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  variantTitle: Scalars['String'];
  name: Scalars['String'];
  SKU: Scalars['String'];
  vendor: Scalars['String'];
  giftCard: Scalars['Boolean'];
  taxable: Scalars['Boolean'];
  variantInventoryManagement: Scalars['String'];
  preTaxPrice?: Maybe<Scalars['Float']>;
  fulfillmentStatus: Scalars['String'];
  product?: Maybe<ShopifyProduct>;
  variant?: Maybe<ShopifyVariant>;
  destination?: Maybe<Destination>;
  design?: Maybe<Design>;
};

export type ShopifyOrder = {
  __typename?: 'ShopifyOrder';
  id: Scalars['Int'];
  name: Scalars['String'];
  email: Scalars['String'];
  createdAt?: Maybe<Scalars['Time']>;
  updatedAt?: Maybe<Scalars['Time']>;
  cancelledAt?: Maybe<Scalars['Time']>;
  closedAt?: Maybe<Scalars['Time']>;
  processedAt?: Maybe<Scalars['Time']>;
  billingAddress?: Maybe<ShopifyAddress>;
  shippingAddress?: Maybe<ShopifyAddress>;
  totalPrice?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  fulfillmentStatus: Scalars['String'];
  fulfillments?: Maybe<Array<ShopifyFulfillment>>;
  lineItems?: Maybe<Array<ShopifyLineItem>>;
  shipping?: Maybe<ShopifyShipping>;
  test: Scalars['Boolean'];
  cancelReason: Scalars['String'];
  videoManifest?: Maybe<Array<Scalars['String']>>;
  videoSHA256: Scalars['String'];
  giftMessage: Scalars['String'];
  vendorSaleId?: Maybe<Scalars['String']>;
  discountCodes?: Maybe<Array<Scalars['String']>>;
};

export type ShopifyOrderInput = {
  email: Scalars['String'];
  address: AddressInput;
  giftMessage: Scalars['String'];
  books: Array<BookLineItemInput>;
  videoManifest?: Maybe<Array<Scalars['String']>>;
};

export type ShopifyProduct = {
  __typename?: 'ShopifyProduct';
  id: Scalars['Int'];
  images?: Maybe<Array<ShopifyImage>>;
  image?: Maybe<ShopifyImage>;
  productType: Scalars['String'];
  title: Scalars['String'];
  bodyHTML: Scalars['String'];
};

export type ShopifyShipping = {
  __typename?: 'ShopifyShipping';
  code: Scalars['String'];
  price: Scalars['String'];
  source: Scalars['String'];
  title: Scalars['String'];
  carrierIdentifier: Scalars['String'];
};

export type ShopifyVariant = {
  __typename?: 'ShopifyVariant';
  id: Scalars['Int'];
  image?: Maybe<ShopifyImage>;
  price: Scalars['Float'];
  SKU: Scalars['String'];
  title: Scalars['String'];
};

export type SignedUrlResponse = {
  __typename?: 'SignedURLResponse';
  unsignedURL: Scalars['String'];
  signedURL: Scalars['String'];
};

export type SignedUrLsResponse = {
  __typename?: 'SignedURLsResponse';
  signedURLs: Array<Scalars['String']>;
};


export type TrackingEvent = {
  __typename?: 'TrackingEvent';
  occurred_at: Scalars['String'];
  description: Scalars['String'];
  event_code: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  signer?: Maybe<Scalars['String']>;
  city_locality?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
};

export type UpdatableCustomerProperties = {
  flagOrders?: Maybe<FlagInfoInput>;
};

export type UpdatableOrderProperties = {
  scheduledDeliveryDate?: Maybe<Scalars['Time']>;
  notes?: Maybe<Array<OrderNoteInput>>;
  manualGain?: Maybe<Scalars['Int']>;
  manualOrientation?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  name: Scalars['String'];
  email: Scalars['String'];
};

export type UserInput = {
  name: Scalars['String'];
  email: Scalars['String'];
};

/**
 * An vendor sale is when we sell one or more cards before they're actually
 * created as a Shopify order. Most commonly this would be us selling through
 * a third-party vendor like UncommonGoods.
 */
export type VendorSale = {
  __typename?: 'VendorSale';
  id: Scalars['ID'];
  vendorId: Scalars['ID'];
  customerEmail: Scalars['String'];
  customerFirstName: Scalars['String'];
  externalOrderId: Scalars['ID'];
  duration: Scalars['Int'];
  quantity: Scalars['Int'];
  shippingSpeed?: Maybe<Scalars['String']>;
  hasGiftBox?: Maybe<Scalars['Boolean']>;
  hasCustomCoverFront?: Maybe<Scalars['Boolean']>;
  hasCustomCoverBack?: Maybe<Scalars['Boolean']>;
  hasCustomCoverFrontInside?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Time'];
  createdBy?: Maybe<Scalars['String']>;
  couponCode?: Maybe<Scalars['String']>;
  deeplinkURL?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['Time']>;
  orders?: Maybe<Array<Order>>;
};

export type VideoConfiguration = {
  __typename?: 'VideoConfiguration';
  gain: Scalars['Int'];
  vertical: Scalars['Boolean'];
  allowVertical: Scalars['Boolean'];
};

export type VideoRef = {
  __typename?: 'VideoRef';
  URL: Scalars['String'];
  SHA256: Scalars['String'];
};

export type VoidResponse = {
  __typename?: 'VoidResponse';
  approved: Scalars['Boolean'];
};

export enum WarehouseCode {
  Dc = 'DC',
  Tx = 'TX'
}

export type AlbumsQueryVariables = Exact<{ [key: string]: never; }>;


export type AlbumsQuery = (
  { __typename?: 'Query' }
  & { albumOrders: Array<(
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'name' | 'state' | 'customerEmail'>
    & { designs?: Maybe<Array<(
      { __typename?: 'DesignWithDestinations' }
      & { design?: Maybe<(
        { __typename?: 'Design' }
        & Pick<Design, 'id'>
      )>, destinations?: Maybe<Array<(
        { __typename?: 'Destination' }
        & Pick<Destination, 'id' | 'state' | 'quantity' | 'albumDesignId' | 'metadataJSON'>
        & { albumDesign?: Maybe<(
          { __typename?: 'AlbumDesign' }
          & Pick<AlbumDesign, 'id'>
          & { pages: Array<(
            { __typename?: 'AlbumPage' }
            & Pick<AlbumPage, 'id' | 'pageNumber' | 'photoThumbnailURL' | 'photoProductionURL' | 'videoMediaId'>
          )> }
        )>, order?: Maybe<(
          { __typename?: 'Order' }
          & Pick<Order, 'name'>
        )> }
      )>> }
    )>> }
  )> }
);

export type AlbumPrintFilesQueryVariables = Exact<{
  albumDesignId: Scalars['ID'];
}>;


export type AlbumPrintFilesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'albumPrintFilesURL'>
);

export type AlbumBatchPrintFilesQueryVariables = Exact<{
  albumDesignIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AlbumBatchPrintFilesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'albumBatchPrintFilesURL'>
);

export type UpdateDestinationMetadataMutationVariables = Exact<{
  destinationID: Scalars['ID'];
  metadataJSON: Scalars['String'];
}>;


export type UpdateDestinationMetadataMutation = (
  { __typename?: 'Mutation' }
  & { updateDestinationMetadata: (
    { __typename?: 'Destination' }
    & Pick<Destination, 'id' | 'metadataJSON'>
  ) }
);

export type AllOrdersQueryVariables = Exact<{
  cursor?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  filters?: Maybe<OrderFilters>;
}>;


export type AllOrdersQuery = (
  { __typename?: 'Query' }
  & { allOrders: (
    { __typename?: 'PaginatedOrders' }
    & Pick<PaginatedOrders, 'cursor'>
    & { orders: Array<(
      { __typename?: 'Order' }
      & Pick<Order, 'id'>
      & OrderDetailsFragment
    )> }
  ) }
);

export type CoverFragment = (
  { __typename?: 'Cover' }
  & Pick<Cover, 'id' | 'createdAt' | 'lastModifiedAt' | 'approvedAt' | 'thumbnailImageURL' | 'productionImageURL'>
  & { usedByDestinations?: Maybe<Array<(
    { __typename?: 'Destination' }
    & Pick<Destination, 'id' | 'designId' | 'state' | 'quantity' | 'coversPrinted' | 'orderId'>
    & { order?: Maybe<(
      { __typename?: 'Order' }
      & Pick<Order, 'name'>
    )> }
  )>> }
);

export type ArtQueryVariables = Exact<{ [key: string]: never; }>;


export type ArtQuery = (
  { __typename?: 'Query' }
  & { activeCustomCovers?: Maybe<Array<(
    { __typename?: 'Cover' }
    & CoverFragment
  )>> }
);

export type ConnectedDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectedDevicesQuery = (
  { __typename?: 'Query' }
  & { devices: Array<Maybe<(
    { __typename?: 'Device' }
    & Pick<Device, 'id' | 'status' | 'transferredOrderId'>
    & { video: (
      { __typename?: 'DeviceVideoStatus' }
      & Pick<DeviceVideoStatus, 'transferStatus' | 'percentageTransferred'>
    ) }
  )>> }
);

export type CreateShopifyOrderMutationVariables = Exact<{
  order: ShopifyOrderInput;
}>;


export type CreateShopifyOrderMutation = (
  { __typename?: 'Mutation' }
  & { createShopifyOrder: (
    { __typename?: 'ShopifyOrder' }
    & Pick<ShopifyOrder, 'id'>
  ) }
);

export type CustomerInfoQueryVariables = Exact<{
  customerID: Scalars['ID'];
}>;


export type CustomerInfoQuery = (
  { __typename?: 'Query' }
  & { customerInfo: (
    { __typename?: 'CustomerWithActivity' }
    & { customer: (
      { __typename?: 'Customer' }
      & Pick<Customer, 'id' | 'email'>
    ), payments: Array<(
      { __typename?: 'Payment' }
      & Pick<Payment, 'id' | 'createdAt' | 'state' | 'amountInCents' | 'amountRefundedInCents' | 'isPreorder' | 'discountId' | 'orderId'>
      & { refunds?: Maybe<Array<(
        { __typename?: 'Refund' }
        & Pick<Refund, 'id' | 'createdAt' | 'amountInCents'>
      )>> }
    )> }
  ) }
);

export type DownloaderQueryQueryVariables = Exact<{
  orderID: Scalars['ID'];
}>;


export type DownloaderQueryQuery = (
  { __typename?: 'Query' }
  & { videoURL: (
    { __typename?: 'VideoRef' }
    & Pick<VideoRef, 'URL' | 'SHA256'>
  ) }
);

export type HelpScoutConversationsQueryVariables = Exact<{
  emails: Array<Scalars['String']> | Scalars['String'];
}>;


export type HelpScoutConversationsQuery = (
  { __typename?: 'Query' }
  & { helpScoutConversations: (
    { __typename?: 'HelpScoutConversationsResponse' }
    & { conversations: Array<(
      { __typename?: 'HelpScoutConversation' }
      & Pick<HelpScoutConversation, 'id' | 'isDraft' | 'number' | 'threadCount' | 'status' | 'subject' | 'preview' | 'createdAt' | 'modifiedAt' | 'closedAt'>
    )> }
  ) }
);

export type LocalOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type LocalOrdersQuery = (
  { __typename?: 'Query' }
  & { orders: Array<(
    { __typename?: 'Order' }
    & OrderDetailsFragment
  )> }
);

export type LoyaltyCodeQueryVariables = Exact<{
  orderID: Scalars['ID'];
}>;


export type LoyaltyCodeQuery = (
  { __typename?: 'Query' }
  & { loyaltyCode: (
    { __typename?: 'LoyaltyCodeResponse' }
    & Pick<LoyaltyCodeResponse, 'link'>
    & { qr: (
      { __typename?: 'QRCode' }
      & Pick<QrCode, 'dataURL'>
    ) }
  ) }
);

export type OrderDetailsFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'id' | 'name' | 'status' | 'createdAt' | 'reservedBy' | 'reservedAt' | 'cardVideoURL' | 'cardVideoSHA256' | 'cardVideoEncodeAttempts' | 'cardVideoEncodeProgress' | 'shareVideoEncodeProgress' | 'shareVideoURL' | 'customerName' | 'scheduledDeliveryDate' | 'manualOrientation' | 'manualGain' | 'loyaltyCode'>
  & { notes?: Maybe<Array<(
    { __typename?: 'OrderNote' }
    & Pick<OrderNote, 'createdAt' | 'content'>
    & { createdBy: (
      { __typename?: 'User' }
      & Pick<User, 'name' | 'email'>
    ) }
  )>>, customer?: Maybe<(
    { __typename?: 'Customer' }
    & Pick<Customer, 'id'>
    & { flagOrders?: Maybe<(
      { __typename?: 'FlagInfo' }
      & Pick<FlagInfo, 'createdByName' | 'createdByEmail' | 'createdAt' | 'description' | 'emoji'>
    )> }
  )>, shopify?: Maybe<(
    { __typename?: 'ShopifyOrder' }
    & Pick<ShopifyOrder, 'email' | 'createdAt' | 'cancelledAt' | 'note' | 'videoManifest'>
    & { shippingAddress?: Maybe<(
      { __typename?: 'ShopifyAddress' }
      & Pick<ShopifyAddress, 'address1' | 'address2' | 'city' | 'company' | 'countryCode' | 'firstName' | 'name' | 'phone' | 'province' | 'provinceCode' | 'zip'>
    )>, shipping?: Maybe<(
      { __typename?: 'ShopifyShipping' }
      & Pick<ShopifyShipping, 'code'>
    )>, lineItems?: Maybe<Array<(
      { __typename?: 'ShopifyLineItem' }
      & Pick<ShopifyLineItem, 'quantity' | 'SKU'>
      & { product?: Maybe<(
        { __typename?: 'ShopifyProduct' }
        & Pick<ShopifyProduct, 'title'>
        & { image?: Maybe<(
          { __typename?: 'ShopifyImage' }
          & Pick<ShopifyImage, 'src'>
        )> }
      )> }
    )>> }
  )>, vendorSale?: Maybe<(
    { __typename?: 'VendorSale' }
    & Pick<VendorSale, 'vendorId' | 'createdAt' | 'cancelledAt' | 'externalOrderId'>
  )>, shippingLabels?: Maybe<Array<(
    { __typename?: 'ShippingLabel' }
    & Pick<ShippingLabel, 'label_id' | 'is_return' | 'created_at' | 'status' | 'voided' | 'shipment_id' | 'tracking_number' | 'tracking_status' | 'estimated_delivery_date' | 'actual_delivery_date' | 'ship_date' | 'carrier_code' | 'service_code'>
    & { label_download?: Maybe<(
      { __typename?: 'LabelDownload' }
      & Pick<LabelDownload, 'pdf' | 'png'>
    )>, form_download?: Maybe<(
      { __typename?: 'FormDownload' }
      & Pick<FormDownload, 'href'>
    )> }
  )>>, cardVideoEncodedConfig?: Maybe<(
    { __typename?: 'VideoConfiguration' }
    & Pick<VideoConfiguration, 'vertical'>
  )>, video: (
    { __typename?: 'CardVideoStatus' }
    & Pick<CardVideoStatus, 'downloadStatus' | 'percentageDownloaded' | 'transferStatus' | 'percentageTransferred'>
  ) }
);

export type OrderInfoQueryVariables = Exact<{
  orderID: Scalars['ID'];
}>;


export type OrderInfoQuery = (
  { __typename?: 'Query' }
  & { order: (
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
    & { designs?: Maybe<Array<(
      { __typename?: 'DesignWithDestinations' }
      & { design?: Maybe<(
        { __typename?: 'Design' }
        & { media?: Maybe<Array<(
          { __typename?: 'MediaEntry' }
          & Pick<MediaEntry, 'encodedLocation' | 'signedThumbnailLocation'>
        )>> }
      )> }
    )>> }
    & OrderDetailsFragment
  ) }
);

export type PipelineQueryVariables = Exact<{ [key: string]: never; }>;


export type PipelineQuery = (
  { __typename?: 'Query' }
  & { orders: Array<(
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'status' | 'cardVideoURL' | 'cardVideoSHA256'>
    & { video: (
      { __typename?: 'CardVideoStatus' }
      & Pick<CardVideoStatus, 'downloadStatus' | 'transferStatus'>
    ) }
  )>, devices: Array<Maybe<(
    { __typename?: 'Device' }
    & Pick<Device, 'id' | 'status' | 'transferredOrderId'>
    & { video: (
      { __typename?: 'DeviceVideoStatus' }
      & Pick<DeviceVideoStatus, 'transferStatus' | 'percentageTransferred'>
    ) }
  )>> }
);

export type PipelineOrderFragment = (
  { __typename?: 'Query' }
  & { orders: Array<(
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'status' | 'cardVideoURL' | 'cardVideoSHA256'>
    & { video: (
      { __typename?: 'CardVideoStatus' }
      & Pick<CardVideoStatus, 'downloadStatus' | 'transferStatus'>
    ) }
  )> }
);

export type PresignUploadQueryVariables = Exact<{
  extension?: Maybe<Scalars['String']>;
}>;


export type PresignUploadQuery = (
  { __typename?: 'Query' }
  & { signUpload: (
    { __typename?: 'SignedURLResponse' }
    & Pick<SignedUrlResponse, 'signedURL' | 'unsignedURL'>
  ) }
);

export type RateQuoteQueryVariables = Exact<{
  orderID: Scalars['ID'];
  fromOrToWarehouse: WarehouseCode;
  isReturn?: Maybe<Scalars['Boolean']>;
  saturdayDelivery?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
}>;


export type RateQuoteQuery = (
  { __typename?: 'Query' }
  & { shippingRates: Array<(
    { __typename?: 'ShippingRate' }
    & Pick<ShippingRate, 'rate_id' | 'carrier_id' | 'delivery_days' | 'estimated_delivery_date' | 'carrier_friendly_name' | 'service_code' | 'service_type' | 'trackable' | 'package_type' | 'saturday_delivery' | 'error_messages' | 'warning_messages'>
    & { shipping_amount: (
      { __typename?: 'ShippingCost' }
      & Pick<ShippingCost, 'currency' | 'amount'>
    ), insurance_amount: (
      { __typename?: 'ShippingCost' }
      & Pick<ShippingCost, 'currency' | 'amount'>
    ), confirmation_amount: (
      { __typename?: 'ShippingCost' }
      & Pick<ShippingCost, 'currency' | 'amount'>
    ), other_amount: (
      { __typename?: 'ShippingCost' }
      & Pick<ShippingCost, 'currency' | 'amount'>
    ) }
  )> }
);

export type ReencodeMutationVariables = Exact<{
  orderID: Scalars['ID'];
}>;


export type ReencodeMutation = (
  { __typename?: 'Mutation' }
  & { reencode: (
    { __typename?: 'OrderResponse' }
    & { order: (
      { __typename?: 'Order' }
      & Pick<Order, 'cardVideoURL' | 'shareVideoURL'>
    ) }
  ) }
);

export type RefundMutationVariables = Exact<{
  paymentID: Scalars['ID'];
  amountInCents: Scalars['Int'];
}>;


export type RefundMutation = (
  { __typename?: 'Mutation' }
  & { refund: (
    { __typename?: 'Payment' }
    & Pick<Payment, 'id' | 'amountRefundedInCents'>
  ) }
);

export type SaveVideoManifestMutationVariables = Exact<{
  orderID: Scalars['ID'];
  newVideoURLs: Array<Scalars['String']> | Scalars['String'];
  prevVideoURLs: Array<Scalars['String']> | Scalars['String'];
}>;


export type SaveVideoManifestMutation = (
  { __typename?: 'Mutation' }
  & { replaceVideos: (
    { __typename?: 'OrderResponse' }
    & { order: (
      { __typename?: 'Order' }
      & { shopify?: Maybe<(
        { __typename?: 'ShopifyOrder' }
        & Pick<ShopifyOrder, 'videoManifest'>
      )> }
    ) }
  ) }
);

export type SearchCustomersQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchCustomersQuery = (
  { __typename?: 'Query' }
  & { searchCustomers: Array<(
    { __typename?: 'Customer' }
    & Pick<Customer, 'id' | 'createdAt' | 'email' | 'paymentCustomerId'>
    & { flagOrders?: Maybe<(
      { __typename?: 'FlagInfo' }
      & Pick<FlagInfo, 'emoji'>
    )>, balance?: Maybe<(
      { __typename?: 'CustomerBalance' }
      & Pick<CustomerBalance, 'cashInCents'>
      & { cashEntries: Array<(
        { __typename?: 'BalanceEntry' }
        & Pick<BalanceEntry, 'id'>
      )>, products: Array<(
        { __typename?: 'CustomerBalanceProduct' }
        & Pick<CustomerBalanceProduct, 'quantity'>
        & { entries: Array<(
          { __typename?: 'BalanceEntry' }
          & Pick<BalanceEntry, 'id'>
        )>, product: (
          { __typename?: 'Product' }
          & Pick<Product, 'id'>
        ) }
      )> }
    )> }
  )> }
);

export type SearchOverlayQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchOverlayQuery = (
  { __typename?: 'Query' }
  & { searchOrders: Array<(
    { __typename?: 'Order' }
    & OrderDetailsFragment
  )> }
);

export type SetOrderStatusMutationVariables = Exact<{
  orderID: Scalars['ID'];
  status: Scalars['String'];
}>;


export type SetOrderStatusMutation = (
  { __typename?: 'Mutation' }
  & { setOrderStatus: (
    { __typename?: 'OrderResponse' }
    & { order: (
      { __typename?: 'Order' }
      & Pick<Order, 'id' | 'status'>
    ) }
  ) }
);

export type SignVideosQueryVariables = Exact<{
  urls: Array<Scalars['String']> | Scalars['String'];
}>;


export type SignVideosQuery = (
  { __typename?: 'Query' }
  & { signVideoURLs: (
    { __typename?: 'SignedURLsResponse' }
    & Pick<SignedUrLsResponse, 'signedURLs'>
  ) }
);

export type UpdateCoverPrintCountMutationVariables = Exact<{
  destinationID: Scalars['ID'];
  oldValue: Scalars['Int'];
  newValue: Scalars['Int'];
}>;


export type UpdateCoverPrintCountMutation = (
  { __typename?: 'Mutation' }
  & { updateCoverPrintCount: (
    { __typename?: 'Destination' }
    & Pick<Destination, 'id' | 'coversPrinted'>
  ) }
);

export type UpdateCustomCoverApprovalMutationVariables = Exact<{
  coverID: Scalars['ID'];
  approved: Scalars['Boolean'];
}>;


export type UpdateCustomCoverApprovalMutation = (
  { __typename?: 'Mutation' }
  & { updateCustomCoverApproval: (
    { __typename?: 'Cover' }
    & Pick<Cover, 'id' | 'approvedAt'>
  ) }
);

export type UpdateCustomerMutationVariables = Exact<{
  customerID?: Maybe<Scalars['ID']>;
  customerEmail?: Maybe<Scalars['String']>;
  fields: Array<Scalars['String']> | Scalars['String'];
  prevValues: UpdatableCustomerProperties;
  newValues: UpdatableCustomerProperties;
}>;


export type UpdateCustomerMutation = (
  { __typename?: 'Mutation' }
  & { updateCustomer: (
    { __typename?: 'Customer' }
    & { flagOrders?: Maybe<(
      { __typename?: 'FlagInfo' }
      & Pick<FlagInfo, 'createdByName' | 'emoji'>
    )> }
  ) }
);

export type UpdateOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  fields: Array<Scalars['String']> | Scalars['String'];
  prevValues: UpdatableOrderProperties;
  newValues: UpdatableOrderProperties;
}>;


export type UpdateOrderMutation = (
  { __typename?: 'Mutation' }
  & { updateOrder: (
    { __typename?: 'OrderResponse' }
    & { order: (
      { __typename?: 'Order' }
      & Pick<Order, 'id' | 'scheduledDeliveryDate' | 'manualOrientation' | 'manualGain'>
      & { notes?: Maybe<Array<(
        { __typename?: 'OrderNote' }
        & Pick<OrderNote, 'id' | 'content' | 'createdAt'>
        & { createdBy: (
          { __typename?: 'User' }
          & Pick<User, 'name' | 'email'>
        ) }
      )>> }
    ) }
  ) }
);

export const CoverFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Cover"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cover"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImageURL"}},{"kind":"Field","name":{"kind":"Name","value":"productionImageURL"}},{"kind":"Field","name":{"kind":"Name","value":"usedByDestinations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"designId"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"coversPrinted"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CoverFragment, unknown>;
export const OrderDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"reservedBy"}},{"kind":"Field","name":{"kind":"Name","value":"reservedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cardVideoURL"}},{"kind":"Field","name":{"kind":"Name","value":"cardVideoSHA256"}},{"kind":"Field","name":{"kind":"Name","value":"cardVideoEncodeAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"cardVideoEncodeProgress"}},{"kind":"Field","name":{"kind":"Name","value":"shareVideoEncodeProgress"}},{"kind":"Field","name":{"kind":"Name","value":"shareVideoURL"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDeliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"manualOrientation"}},{"kind":"Field","name":{"kind":"Name","value":"manualGain"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyCode"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flagOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdByName"}},{"kind":"Field","name":{"kind":"Name","value":"createdByEmail"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shopify"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"videoManifest"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"provinceCode"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"SKU"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorSale"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalOrderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_return"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"voided"}},{"kind":"Field","name":{"kind":"Name","value":"shipment_id"}},{"kind":"Field","name":{"kind":"Name","value":"tracking_number"}},{"kind":"Field","name":{"kind":"Name","value":"tracking_status"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_delivery_date"}},{"kind":"Field","name":{"kind":"Name","value":"actual_delivery_date"}},{"kind":"Field","name":{"kind":"Name","value":"ship_date"}},{"kind":"Field","name":{"kind":"Name","value":"carrier_code"}},{"kind":"Field","name":{"kind":"Name","value":"service_code"}},{"kind":"Field","name":{"kind":"Name","value":"label_download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pdf"}},{"kind":"Field","name":{"kind":"Name","value":"png"}}]}},{"kind":"Field","name":{"kind":"Name","value":"form_download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"href"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardVideoEncodedConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vertical"}}]}},{"kind":"Field","name":{"kind":"Name","value":"video"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"percentageDownloaded"}},{"kind":"Field","name":{"kind":"Name","value":"transferStatus"}},{"kind":"Field","name":{"kind":"Name","value":"percentageTransferred"}}]}}]}}]} as unknown as DocumentNode<OrderDetailsFragment, unknown>;
export const PipelineOrderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PipelineOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Query"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cardVideoURL"}},{"kind":"Field","name":{"kind":"Name","value":"cardVideoSHA256"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"transferStatus"}}]}}]}}]}}]} as unknown as DocumentNode<PipelineOrderFragment, unknown>;
export const AlbumsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Albums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"albumOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"designs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"design"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"destinations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"albumDesignId"}},{"kind":"Field","name":{"kind":"Name","value":"albumDesign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"photoThumbnailURL"}},{"kind":"Field","name":{"kind":"Name","value":"photoProductionURL"}},{"kind":"Field","name":{"kind":"Name","value":"videoMediaId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadataJSON"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AlbumsQuery, AlbumsQueryVariables>;
export const AlbumPrintFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AlbumPrintFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"albumDesignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"albumPrintFilesURL"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"albumDesignId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"albumDesignId"}}}]}]}}]} as unknown as DocumentNode<AlbumPrintFilesQuery, AlbumPrintFilesQueryVariables>;
export const AlbumBatchPrintFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AlbumBatchPrintFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"albumDesignIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"albumBatchPrintFilesURL"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"albumDesignIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"albumDesignIds"}}}]}]}}]} as unknown as DocumentNode<AlbumBatchPrintFilesQuery, AlbumBatchPrintFilesQueryVariables>;
export const UpdateDestinationMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDestinationMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destinationID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadataJSON"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDestinationMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"destinationID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destinationID"}}},{"kind":"Argument","name":{"kind":"Name","value":"metadataJSON"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadataJSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadataJSON"}}]}}]}}]} as unknown as DocumentNode<UpdateDestinationMetadataMutation, UpdateDestinationMetadataMutationVariables>;
export const AllOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilters"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails"}}]}}]}}]}},...OrderDetailsFragmentDoc.definitions]} as unknown as DocumentNode<AllOrdersQuery, AllOrdersQueryVariables>;
export const ArtDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Art"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeCustomCovers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Cover"}}]}}]}},...CoverFragmentDoc.definitions]} as unknown as DocumentNode<ArtQuery, ArtQueryVariables>;
export const ConnectedDevicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConnectedDevices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devices"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"transferredOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferStatus"}},{"kind":"Field","name":{"kind":"Name","value":"percentageTransferred"}}]}}]}}]}}]} as unknown as DocumentNode<ConnectedDevicesQuery, ConnectedDevicesQueryVariables>;
export const CreateShopifyOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateShopifyOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShopifyOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShopifyOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateShopifyOrderMutation, CreateShopifyOrderMutationVariables>;
export const CustomerInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"amountRefundedInCents"}},{"kind":"Field","name":{"kind":"Name","value":"isPreorder"}},{"kind":"Field","name":{"kind":"Name","value":"discountId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"refunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomerInfoQuery, CustomerInfoQueryVariables>;
export const DownloaderQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloaderQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoURL"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"URL"}},{"kind":"Field","name":{"kind":"Name","value":"SHA256"}}]}}]}}]} as unknown as DocumentNode<DownloaderQueryQuery, DownloaderQueryQueryVariables>;
export const HelpScoutConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HelpScoutConversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"helpScoutConversations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerEmails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emails"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDraft"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"threadCount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"preview"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}}]}}]}}]}}]} as unknown as DocumentNode<HelpScoutConversationsQuery, HelpScoutConversationsQueryVariables>;
export const LocalOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocalOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails"}}]}}]}},...OrderDetailsFragmentDoc.definitions]} as unknown as DocumentNode<LocalOrdersQuery, LocalOrdersQueryVariables>;
export const LoyaltyCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataURL"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<LoyaltyCodeQuery, LoyaltyCodeQueryVariables>;
export const OrderInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"designs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"design"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"encodedLocation"}},{"kind":"Field","name":{"kind":"Name","value":"signedThumbnailLocation"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails"}}]}}]}},...OrderDetailsFragmentDoc.definitions]} as unknown as DocumentNode<OrderInfoQuery, OrderInfoQueryVariables>;
export const PipelineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cardVideoURL"}},{"kind":"Field","name":{"kind":"Name","value":"cardVideoSHA256"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"transferStatus"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"transferredOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferStatus"}},{"kind":"Field","name":{"kind":"Name","value":"percentageTransferred"}}]}}]}}]}}]} as unknown as DocumentNode<PipelineQuery, PipelineQueryVariables>;
export const PresignUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PresignUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"extension"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"extension"},"value":{"kind":"Variable","name":{"kind":"Name","value":"extension"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signedURL"}},{"kind":"Field","name":{"kind":"Name","value":"unsignedURL"}}]}}]}}]} as unknown as DocumentNode<PresignUploadQuery, PresignUploadQueryVariables>;
export const RateQuoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RateQuote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromOrToWarehouse"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WarehouseCode"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isReturn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"saturdayDelivery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingRates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromOrToWarehouse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromOrToWarehouse"}}},{"kind":"Argument","name":{"kind":"Name","value":"isReturn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isReturn"}}},{"kind":"Argument","name":{"kind":"Name","value":"saturdayDelivery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"saturdayDelivery"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate_id"}},{"kind":"Field","name":{"kind":"Name","value":"carrier_id"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_days"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_delivery_date"}},{"kind":"Field","name":{"kind":"Name","value":"carrier_friendly_name"}},{"kind":"Field","name":{"kind":"Name","value":"service_code"}},{"kind":"Field","name":{"kind":"Name","value":"service_type"}},{"kind":"Field","name":{"kind":"Name","value":"trackable"}},{"kind":"Field","name":{"kind":"Name","value":"package_type"}},{"kind":"Field","name":{"kind":"Name","value":"saturday_delivery"}},{"kind":"Field","name":{"kind":"Name","value":"shipping_amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insurance_amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmation_amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"other_amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error_messages"}},{"kind":"Field","name":{"kind":"Name","value":"warning_messages"}}]}}]}}]} as unknown as DocumentNode<RateQuoteQuery, RateQuoteQueryVariables>;
export const ReencodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Reencode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reencode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardVideoURL"}},{"kind":"Field","name":{"kind":"Name","value":"shareVideoURL"}}]}}]}}]}}]} as unknown as DocumentNode<ReencodeMutation, ReencodeMutationVariables>;
export const RefundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Refund"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amountInCents"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refund"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"paymentID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentID"}}},{"kind":"Argument","name":{"kind":"Name","value":"amountInCents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amountInCents"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amountRefundedInCents"}}]}}]}}]} as unknown as DocumentNode<RefundMutation, RefundMutationVariables>;
export const SaveVideoManifestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveVideoManifest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newVideoURLs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prevVideoURLs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"replaceVideos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}}},{"kind":"Argument","name":{"kind":"Name","value":"newVideoURLs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newVideoURLs"}}},{"kind":"Argument","name":{"kind":"Name","value":"prevVideoURLs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prevVideoURLs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopify"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoManifest"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SaveVideoManifestMutation, SaveVideoManifestMutationVariables>;
export const SearchCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchCustomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchCustomers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"flagOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"balance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cashInCents"}},{"kind":"Field","name":{"kind":"Name","value":"cashEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchCustomersQuery, SearchCustomersQueryVariables>;
export const SearchOverlayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchOverlay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails"}}]}}]}},...OrderDetailsFragmentDoc.definitions]} as unknown as DocumentNode<SearchOverlayQuery, SearchOverlayQueryVariables>;
export const SetOrderStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetOrderStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setOrderStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<SetOrderStatusMutation, SetOrderStatusMutationVariables>;
export const SignVideosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SignVideos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urls"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signVideoURLs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"urls"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urls"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signedURLs"}}]}}]}}]} as unknown as DocumentNode<SignVideosQuery, SignVideosQueryVariables>;
export const UpdateCoverPrintCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCoverPrintCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destinationID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCoverPrintCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"destinationID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destinationID"}}},{"kind":"Argument","name":{"kind":"Name","value":"oldValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldValue"}}},{"kind":"Argument","name":{"kind":"Name","value":"newValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValue"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"coversPrinted"}}]}}]}}]} as unknown as DocumentNode<UpdateCoverPrintCountMutation, UpdateCoverPrintCountMutationVariables>;
export const UpdateCustomCoverApprovalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomCoverApproval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coverID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approved"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomCoverApproval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"coverID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coverID"}}},{"kind":"Argument","name":{"kind":"Name","value":"approved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approved"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomCoverApprovalMutation, UpdateCustomCoverApprovalMutationVariables>;
export const UpdateCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fields"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prevValues"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatableCustomerProperties"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValues"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatableCustomerProperties"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerID"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"fields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fields"}}},{"kind":"Argument","name":{"kind":"Name","value":"prevValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prevValues"}}},{"kind":"Argument","name":{"kind":"Name","value":"newValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValues"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdByName"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const UpdateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fields"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prevValues"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatableOrderProperties"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newValues"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatableOrderProperties"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fields"}}},{"kind":"Argument","name":{"kind":"Name","value":"prevValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prevValues"}}},{"kind":"Argument","name":{"kind":"Name","value":"newValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newValues"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDeliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"manualOrientation"}},{"kind":"Field","name":{"kind":"Name","value":"manualGain"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrderMutation, UpdateOrderMutationVariables>;